
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Puneoutstationcabs() {



    const cardData =
    {
        keyword: ' Pune Outstation Cabs',
        heading: 'Prince Cabs: Pune Outstation Cabs',
        headingDescription: 'Prince Cabs provides dependable Pune Outstation Cabs, ideal for weekend getaways, family tours, pilgrimages, and business trips. Our fleet of well-maintained sedans, SUVs, and luxury cars ensures a safe, comfortable, and affordable ride to popular destinations like Mumbai, Shirdi, Nashik, Mahabaleshwar, Goa, and more. With professional chauffeurs, flexible schedules, and transparent pricing, we make every outstation journey smooth and hassle-free. Choose Prince Cabs’ trusted outstation cab service from Pune for reliability, convenience, and complete peace of mind.',

        top: 'Top Places to Visit in Mumbai with Prince Cabs',

"topPlaces": [
  {
    "title": "Lonavala & Khandala",
    "description": "Lonavala and Khandala are the most famous hill stations near Pune, just 65 km away. Known for their lush valleys, waterfalls, and misty hills, they are a monsoon paradise. Popular spots include Tiger’s Leap, Bhushi Dam, and Duke’s Nose. Adventure lovers enjoy trekking and camping, while families love picnics and leisure walks. The twin towns are also famous for chikki and fudge. Lonavala–Khandala are Pune’s favorite weekend getaways."
  },
  {
    "title": "Mahabaleshwar",
    "description": "Mahabaleshwar, about 120 km from Pune, is a hill station surrounded by the Western Ghats. It is famous for viewpoints like Arthur’s Seat, Wilson Point, and Elephant’s Head. Venna Lake boating and strawberry farms are major attractions. The town also has historic temples like Mahabaleshwar Temple and Pratapgad Fort nearby. It is a year-round destination with cool weather and scenic landscapes. Mahabaleshwar is Pune’s top outstation retreat."
  },
  {
    "title": "Lavasa",
    "description": "Lavasa, located 60 km from Pune, is a planned hill city modeled after Italian towns. It is known for its lakeside promenade, adventure sports, and colorful architecture. Boating, cycling, and nature walks are popular activities here. Surrounded by hills, it is especially scenic during monsoon. Cafés and resorts around the lake make it a relaxing escape. Lavasa is Pune’s modern and vibrant outstation spot."
  },
  {
    "title": "Matheran",
    "description": "Matheran, 120 km from Pune, is Asia’s only automobile-free hill station. It is famous for its toy train ride and panoramic viewpoints like Panorama Point and Louisa Point. Dense forests and colonial-era charm make it unique. Trekking and horse riding are popular activities. The cool climate makes it perfect for weekend getaways. Matheran offers a pollution-free and peaceful escape from Pune."
  },
  {
    "title": "Alibaug",
    "description": "Alibaug, 140 km from Pune, is a coastal town famous for its beaches and forts. Alibaug Beach, Kashid Beach, and Nagaon Beach are popular for water sports and relaxation. Kolaba Fort, located in the sea, adds historic charm. The town is also known for homestays and seafood. It is a favorite weekend destination for Puneites. Alibaug blends beach fun with cultural heritage."
  },
  {
    "title": "Goa",
    "description": "Goa, about 450 km from Pune, is India’s party capital and beach paradise. North Goa is famous for nightlife and water sports, while South Goa is serene with luxury resorts. Key attractions include Baga Beach, Dudhsagar Waterfalls, and Basilica of Bom Jesus. Adventure lovers enjoy scuba diving, parasailing, and trekking. Goan cuisine and vibrant culture add flavor to the trip. Goa is Pune’s ultimate long-drive destination."
  },
  {
    "title": "Shirdi",
    "description": "Shirdi, 185 km from Pune, is one of India’s most visited pilgrimage sites. It is home to the famous Shirdi Sai Baba Temple, which attracts devotees from across the world. The temple complex includes Dwarkamai, Chavadi, and Gurusthan. Daily aartis and prayers create a spiritual atmosphere. The town also has museums and parks for visitors. Shirdi is Pune’s most popular religious outstation trip."
  },
  {
    "title": "Nashik",
    "description": "Nashik, about 210 km from Pune, is known as the Wine Capital of India. It is also a sacred city with the Trimbakeshwar Jyotirlinga and Godavari Ghats. Vineyards like Sula and York offer wine-tasting tours. Nashik hosts the Kumbh Mela every 12 years, attracting millions of pilgrims. The city blends spirituality with modern attractions. Nashik is a perfect outstation mix of devotion and leisure."
  },
  {
    "title": "Kolhapur",
    "description": "Kolhapur, located 230 km from Pune, is famous for the Mahalaxmi Temple and rich Maratha heritage. The city is known for its spicy Kolhapuri cuisine, including tambda and pandhra rassa. Other attractions include Rankala Lake, New Palace Museum, and Panhala Fort. The city is also famous for Kolhapuri chappals and jewelry. Festivals here are celebrated with grandeur. Kolhapur is Pune’s cultural and spiritual outstation spot."
  },
  {
    "title": "Aurangabad",
    "description": "Aurangabad, 240 km from Pune, is a heritage city with UNESCO-listed Ajanta and Ellora Caves. Grishneshwar Jyotirlinga Temple and Daulatabad Fort add to its historic charm. The city is also home to Bibi ka Maqbara, a Taj Mahal-inspired monument. Aurangabad is known as the Tourism Capital of Maharashtra. Handicrafts like Himroo shawls and Paithani sarees are popular here. It is Pune’s heritage-rich outstation trip."
  },
  {
    "title": "Satara & Kaas Plateau",
    "description": "Satara, about 110 km from Pune, is famous for the Kaas Plateau, a UNESCO-listed biodiversity hotspot. Known as the Valley of Flowers of Maharashtra, it blooms with thousands of wildflowers in September. Other attractions include Ajinkyatara Fort, Thoseghar Waterfalls, and Sajjangad. The region is scenic during monsoon with misty hills. Satara is a paradise for nature lovers and photographers. It is Pune’s colorful weekend escape."
  },
  {
    "title": "Bhimashankar",
    "description": "Bhimashankar, 110 km from Pune, is a famous Jyotirlinga shrine dedicated to Lord Shiva. Located in the Sahyadri Hills, it is surrounded by dense forests and wildlife. The Bhimashankar Wildlife Sanctuary is home to the Indian Giant Squirrel. Pilgrims and trekkers alike love this destination. The temple’s Nagara-style architecture adds historical charm. Bhimashankar is both a spiritual and adventure outstation trip."
  },
  {
    "title": "Dapoli",
    "description": "Dapoli, located 215 km from Pune, is a coastal town known as Mini Mahabaleshwar of Konkan. It is famous for its beaches like Murud, Ladghar, and Anjarle. Dolphin-spotting boat rides are a major attraction here. The town is also known for ancient temples and forts. Fresh seafood and Konkani cuisine add flavor to the trip. Dapoli is Pune’s refreshing seaside getaway."
  },
  {
    "title": "Ganpatipule",
    "description": "Ganpatipule, 330 km from Pune, is a serene beach town on the Konkan coast. The 400-year-old Swayambhu Ganapati Temple is its prime attraction. The clean sandy beach is perfect for relaxation and water sports. Nearby attractions include Jaigad Fort and Malgund village. It is less commercialized, offering peace and natural beauty. Ganpatipule is Pune’s spiritual and coastal outstation destination."
  },
  {
    "title": "Ajanta & Ellora Caves",
    "description": "Ajanta and Ellora Caves near Aurangabad are UNESCO World Heritage Sites. Ajanta features Buddhist rock-cut caves with paintings and sculptures dating back to 2nd century BC. Ellora showcases Hindu, Buddhist, and Jain caves with the grand Kailasa Temple. The artistry and architecture are breathtaking. Tourists from across the world visit these ancient wonders. Ajanta–Ellora are Pune’s most iconic heritage outstation attractions."
  }
],


       "services": [
    {
      "name": "Pune Outstation Taxi Booking",
      "description": "Arrange hassle-free outstation journeys from Pune with our reliable outstation taxi booking service. Choose the right vehicle—be it a compact sedan, spacious MPV, or sturdy SUV—paired with experienced drivers who prioritize punctuality and comfort, ensuring a smooth travel experience beyond city limits."
    },
    {
      "name": "Innova Crysta for Outstation Pune",
      "description": "Travel in style and comfort for your outstation trips with Innova Crysta from Pune. Designed for groups and families, this premium MPV offers plush interiors, ample luggage space, and an exceptionally smooth ride for longer distances."
    },
    {
      "name": "Pune to Mahabaleshwar Outstation Cab",
      "description": "Book a comfortable and convenient cab from Pune to Mahabaleshwar for scenic hill station getaways. Select from well-maintained sedans and MPVs, driven by skilled drivers familiar with ghat routes and terrain."
    },
    {
      "name": "Dzire Outstation Cab Pune",
      "description": "Choose the Swift Dzire for efficient and affordable outstation travel from Pune. Comfortable, fuel-efficient, and air-conditioned, it’s ideal for solo travelers or small groups covering nearby destinations."
    },
    {
      "name": "Pune to Shirdi Outstation Taxi",
      "description": "Plan your pilgrimage to Shirdi with our dedicated outstation taxi service. Travel comfortably in a clean, air-conditioned vehicle with trusted drivers who know the route and can help you manage travel logistics seamlessly."
    },
    {
      "name": "Pune to Goa Outstation Car Rental",
      "description": "Embark on a scenic road trip with our outstation car rental service from Pune to Goa. Choose from spacious MPVs like Innova or Ertiga, complete with drivers, to enjoy comfort, ample storage, and smooth drive along the coast."
    },
    {
      "name": "Etios Outstation Taxi Pune",
      "description": "Hire the Toyota Etios for efficient and dependable outstation fare from Pune. With its comfortable interiors, good mileage, and smooth handling, the Etios is great for small parties and budget-conscious travelers."
    },
    {
      "name": "Outstation SUV Cab from Pune",
      "description": "Go rugged with our SUV outstation cab service from Pune. Superior ground clearance, strong performance, and spacious seating make SUVs like the Fortuner or Safari perfect for adventurous routes or group travel."
    },
    {
      "name": "Pune to Mumbai Outstation Cabs",
      "description": "Simplify your intercity commute with outstation cab services from Pune to Mumbai. Choose from a fleet of MPVs, sedans, and SUVs, all with experienced drivers and transparent pricing for reliable and comfortable travel."
    },
    {
      "name": "Ertiga Outstation Taxi Pune",
      "description": "Rent a comfortable Ertiga cab for your outstation travel needs. Perfect for groups and longer journeys, this 7-seater offers AC comfort, a smooth ride, and spacious luggage room for hassle-free travel."
    },
    {
      "name": "Pune to Nashik Outstation Cab",
      "description": "Book a reliable cab for your trip from Pune to Nashik. Whether you're planning a winery tour or visiting religious sites, our well-maintained vehicles and experienced drivers ensure a comfortable ride."
    },
    {
      "name": "Affordable Outstation Cabs Pune",
      "description": "Travel beyond Pune without breaking the bank—our affordable outstation cab options offer value-for-money services in clean, safe vehicles, backed by professional drivers and straightforward pricing."
    },
    {
      "name": "Round Trip Outstation Cabs Pune",
      "description": "Book round-trip outstation cabs from Pune with flexible pickup and return scheduling. Ideal for overnight trips, weekend getaways, or pilgrimage visits, with optional waiting time built into your package."
    },
    {
      "name": "Local to Outstation Cab Pune",
      "description": "Need both local and outstation transport from Pune? We’ve got you covered—affordable hybrids that let you use the cab within Pune before heading out of town, all within a single booking."
    },
    {
      "name": "7 Seater Outstation Rental Pune",
      "description": "Travelling in larger groups? Opt for our 7-seater rentals from Pune for outstation use. Ideal for families, groups, or events, these spacious MPVs ensure comfort, luggage capacity, and consistent service."
    }
  ],
  "tableData": [
    ["Pune Outstation Taxi Booking", "Innova Crysta for Outstation Pune"],
    ["Pune to Mahabaleshwar Outstation Cab", "Dzire Outstation Cab Pune"],
    ["Pune to Shirdi Outstation Taxi", "Pune to Goa Outstation Car Rental"],
    ["Etios Outstation Taxi Pune", "Outstation SUV Cab from Pune"],
    ["Pune to Mumbai Outstation Cabs", "Ertiga Outstation Taxi Pune"],
    ["Pune to Nashik Outstation Cab", "Affordable Outstation Cabs Pune"],
    ["Round Trip Outstation Cabs Pune", "Local to Outstation Cab Pune"],
    ["7 Seater Outstation Rental Pune"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Outstation Cabs from Pune",
    "WhyChoosedescription": "Prince Cabs provides dependable and efficient outstation cab services from Pune to various destinations across Maharashtra and beyond. Whether you're planning a family vacation, business trip, temple visit, or weekend getaway, our outstation cab services ensure on-time pickups, professional drivers, and a comfortable travel experience for every trip."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles for Every Type of Journey",
    "WhyChoosedescription": "Choose from a diverse fleet including Swift Dzire, Ertiga, Innova, Innova Crysta, Tempo Traveller, and more—ideal for solo travelers, families, and large groups. All vehicles are well-maintained, spacious, air-conditioned, and equipped with essential safety features for long-distance travel comfort."
  },
  {
    "WhyChooseheading": "Flexible One-Way, Round Trip & Multi-Day Options",
    "WhyChoosedescription": "We offer fully customizable rental plans based on your travel needs. Whether you want a one-way drop, same-day return, or multi-day round trip, our booking system adapts to your schedule. Perfect for hill stations, pilgrimage sites, beach destinations, and corporate travel across cities from Pune."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Long-Distance Travel Expertise",
    "WhyChoosedescription": "Our courteous and trained drivers have deep knowledge of popular outstation routes like Pune to Mumbai, Mahabaleshwar, Shirdi, Goa, Lonavala, Nashik, and more. They ensure safe driving, smart route planning, and make timely stops for food, fuel, or rest breaks."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Costs",
    "WhyChoosedescription": "Our outstation cab fares from Pune are clear, competitive, and all-inclusive—covering fuel, driver allowance, tolls, and taxes. You receive a detailed fare estimate before confirmation. Payments can be made securely via UPI, credit/debit cards, net banking, or cash."
  },
  {
    "WhyChooseheading": "Clean, Sanitized & Well-Maintained Vehicles",
    "WhyChoosedescription": "Your safety and hygiene are our top priorities. All our cabs are sanitized before each trip and undergo regular maintenance. Vehicles are equipped with seat belts, airbags, first aid kits, and comfortable interiors to ensure a worry-free journey."
  },
  {
    "WhyChooseheading": "24/7 Support for Bookings & On-Trip Assistance",
    "WhyChoosedescription": "Our dedicated customer support team is available round the clock to assist with your bookings, schedule changes, route planning, and real-time travel assistance. Whether you’re planning in advance or booking last-minute, we’re here to help you travel stress-free."
  }
]
























    }

const faqData = [
    {
        question: 'Does Prince Cabs offer outstation cab services from Pune?',
        answer: 'Yes, Prince Cabs provides reliable and well-maintained outstation cab services from Pune to various destinations across Maharashtra and beyond.',
    },
    {
        question: 'What are the popular outstation routes from Pune offered by Prince Cabs?',
        answer: 'Popular routes include Pune to Mumbai, Mahabaleshwar, Goa, Shirdi, Nashik, Lonavala, Aurangabad, and Kolhapur among others.',
    },
    {
        question: 'What types of vehicles are available for outstation travel?',
        answer: 'We offer a wide range of vehicles including Swift Dzire, Ertiga, Innova, and Tempo Traveller to suit individuals, families, and large groups.',
    },
    {
        question: 'Are the cabs safe and comfortable for long-distance travel?',
        answer: 'Absolutely! All our cabs are sanitized, well-maintained, and driven by experienced professionals to ensure a safe and smooth journey.',
    },
    {
        question: 'Is round-trip booking available for outstation cabs from Pune?',
        answer: 'Yes, we offer flexible one-way and round-trip bookings based on your travel plan and convenience.',
    },
    {
        question: 'What are the charges for Pune outstation cab services?',
        answer: 'Fares vary based on distance, vehicle type, and trip duration. Contact Prince Cabs for transparent and competitive pricing.',
    },
    {
        question: 'How do I book an outstation cab from Pune?',
        answer: 'Booking is simple—use our website or call our customer support team to reserve your outstation cab quickly and easily.',
    },
];

const testimonials = [
    {
        name: "Mr. Vinay Joshi",
        position: "Business Traveler",
        text: "I booked an outstation cab from Pune to Aurangabad with Prince Cabs. Excellent service, clean vehicle, and a very courteous driver.",
        image: "/img/testimonial/testimonial-thumb-outstation-pune-1.png",
    },
    {
        name: "Ms. Priya Nair",
        position: "Tourist",
        text: "Prince Cabs made our Pune to Mahabaleshwar weekend trip smooth and relaxing. Highly recommended for outstation journeys.",
        image: "/img/testimonial/testimonial-thumb-outstation-pune-2.png",
    },
];





















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Pune Outstation Cabs",
  "description": "Book Pune outstation taxi services including Innova Crysta, Dzire, Etios, Ertiga, SUV cabs for trips to Mahabaleshwar, Shirdi, Goa, Mumbai, Nashik and more. Affordable round trip and 7 seater rentals available.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Prince Cabs",
    "telephone": "+91-XXXXXXXXXX",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Pune",
      "addressRegion": "Maharashtra",
      "addressCountry": "IN"
    }
  },
  "areaServed": {
    "@type": "Place",
    "name": "Pune"
  },
  "serviceType": [
    "Outstation Taxi Booking",
    "Innova Crysta Rental",
    "Dzire Outstation Cab",
    "Etios Outstation Taxi",
    "SUV Outstation Cab",
    "Ertiga Outstation Taxi",
    "Round Trip Outstation Cabs",
    "7 Seater Outstation Rental",
    "Local to Outstation Cab"
  ],
  "additionalProperty": {
    "@type": "PropertyValue",
    "name": "Affordable",
    "value": "Affordable and Comfortable Outstation Cabs"
  }
};





    return (
        <div>
<Helmet>
  <title>Pune Outstation Cabs | Affordable Taxi Booking for Outstation Trips</title>
  <meta
    name="description"
    content="Book Pune outstation taxi services including Innova Crysta, Dzire, Etios, Ertiga, SUV cabs for trips to Mahabaleshwar, Shirdi, Goa, Mumbai, Nashik and more. Affordable round trip and 7 seater rentals available."
  />
  <meta
    name="keywords"
    content="Pune Outstation Taxi Booking, Innova Crysta for Outstation Pune, Pune to Mahabaleshwar Outstation Cab, Dzire Outstation Cab Pune, Pune to Shirdi Outstation Taxi, Pune to Goa Outstation Car Rental, Etios Outstation Taxi Pune, Outstation SUV Cab from Pune, Pune to Mumbai Outstation Cabs, Ertiga Outstation Taxi Pune, Pune to Nashik Outstation Cab, Affordable Outstation Cabs Pune, Round Trip Outstation Cabs Pune, Local to Outstation Cab Pune, 7 Seater Outstation Rental Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/83.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Puneoutstationcabs ;